__turbopack_context__.v({
  "about-us-leadership-section": "_4GmXZa_about-us-leadership-section",
  "collapse-button": "_4GmXZa_collapse-button",
  "collapsible": "_4GmXZa_collapsible",
  "content-container": "_4GmXZa_content-container",
  "item": "_4GmXZa_item",
  "title": "_4GmXZa_title",
});
